import { render, staticRenderFns } from "./clientFilter.vue?vue&type=template&id=3c5fe712&scoped=true"
import script from "./clientFilter.vue?vue&type=script&lang=js"
export * from "./clientFilter.vue?vue&type=script&lang=js"
import style1 from "./clientFilter.vue?vue&type=style&index=1&id=3c5fe712&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5fe712",
  null
  
)

export default component.exports